import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_FEEDBACK = "feedback";

const getData = async (props: {
  token: string;
}): Promise<any> => {
  const url = `${END_POINT.BASE_URL}/v1/invites/feedback-needed`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: any = res.data;
  return item;
};

const FEEDBACK_STALE_MS = 60 * 1000;

export const useGetFeedback = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_FEEDBACK],
    () =>
      getData({
        token,
      }),
    {
      enabled: !!token,
      staleTime: FEEDBACK_STALE_MS,
      onError: (err: any) => {},
      onSuccess: (data) => {},
    },
  );
  return queryData;
};
